__turbopack_context__.v({
  "bar": "teacher-goal-module__R3Mzla__bar",
  "chipRing": "teacher-goal-module__R3Mzla__chipRing",
  "chipVeil": "teacher-goal-module__R3Mzla__chipVeil",
  "fadeIn": "teacher-goal-module__R3Mzla__fadeIn",
  "goal": "teacher-goal-module__R3Mzla__goal",
  "goals": "teacher-goal-module__R3Mzla__goals",
  "insetIn": "teacher-goal-module__R3Mzla__insetIn",
  "pulse": "teacher-goal-module__R3Mzla__pulse",
  "relight": "teacher-goal-module__R3Mzla__relight",
  "root": "teacher-goal-module__R3Mzla__root",
  "sonar": "teacher-goal-module__R3Mzla__sonar",
  "strip": "teacher-goal-module__R3Mzla__strip",
  "stripIcon": "teacher-goal-module__R3Mzla__stripIcon",
  "stripText": "teacher-goal-module__R3Mzla__stripText",
  "target": "teacher-goal-module__R3Mzla__target",
  "targetBody": "teacher-goal-module__R3Mzla__targetBody",
});
